import { useMutation, useQuery } from "react-query"
import { useToast } from "../../../hook/usetoast";
import DataService from '../../../config/DataServices';

const { postRequest,getRequest} = DataService()


export const useGetCurrency = () => {

    return useQuery({
        queryKey: ["get-currency"],
        queryFn: () => {
            return getRequest(`user/get_currency`)
        }
    })
}


export const useGetaddminaddress = () => {

    return useQuery({
        queryKey: ["get-adminaddress"],
        queryFn: () => {
            return getRequest(`admin/get_admin_address`)
        }
    })
}



export const useBonus = () => {

    return useQuery({
        queryKey: ["get-Bonus"],
        queryFn: () => {
            return getRequest(`user/get-bonus`)
        }
    })
}

export const useBuyToken = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/buy-token", {...data})
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }

            return toast.success(success?.message)
        }
    })
}

export const useChooseCurrency = ({ currencySymbol}) => {

    return useQuery({
        queryKey: ["list-curncy", currencySymbol],
        queryFn: () => {
            return getRequest(`user/currency?currencySymbol=${currencySymbol}`)
        },
        enabled : !!currencySymbol

    })
}





export const usePaymentAvailable = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/check-availablity", {...data})
        },
        onSuccess: success => {

            if (!success?.status) {
                return toast.error(success?.message)
            }

        }
    })
}

export const usePawaPay = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return postRequest("user/pawapay", {...data})
        },
        onSuccess: success => {

            if (success?.status === 'REJECTED' || success[0]?.status === 'FAILED' ) {
                return toast.error(success?.rejectionReason?.rejectionMessage || success[0]?.failureReason?.failureMessage)
            }
        },
        onError:error =>{
            return toast.error("Authentication error")
        }
    })
}